import React from 'react'

const SongDisplay = ({ currentSong, roomCode, children, controlsVisible = true }) => {
  const joinUrl = typeof window !== 'undefined' ? window.location.origin : ''
  const emptyStateMessage = roomCode && joinUrl
    ? `Scan the QR code or head to ${joinUrl} and use code ${roomCode} to start adding songs to the queue!`
    : 'Scan the QR code to start adding songs to the queue!'

  return (
    <div className={`flex-1 flex flex-col px-8 py-4 min-h-0 transition-all duration-500 ${controlsVisible ? 'pb-4' : 'pb-8'}`} style={{ paddingTop: '120px' }}>

      {/* Lyrics Container */}
      <div className="lyrics-container w-full mx-auto flex-1 flex flex-col min-h-0">
        {currentSong ? (
          children
        ) : (
          <div className="flex-1 flex items-center justify-center text-white/60">
            <p className="text-lg text-center max-w-2xl">{emptyStateMessage}</p>
          </div>
        )}
      </div>
    </div>
  )
}

export default SongDisplay
